<template>
    <div>
        <div style="display: flex; justify-content: space-between">
            <h1 style="margin-bottom: 20px; display: flex; align-items: center">
                Fulfillment
            </h1>
            <div>
                <slot name="search-input"></slot>
                <slot name="buttons"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
    ],
    data() {
        return {
        };
    },
    methods: {
    }
}
</script>
